import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getWinners = createAsyncThunk(
  'winners/getWinners',
  async () => {
    const winners = await instanceAPI.get('/get-winners')
      .then((resp) => resp.data.winners);
    return winners;
  },
);

const winnersSlice = createSlice({
  name: 'winners',
  initialState: {
    winners: [],
    status: null,
  },
  extraReducers: {
    [getWinners.pending]: (state) => {
      state.status = 'loading';
    },
    [getWinners.fulfilled]: (state, action) => {
      state.status = 'success';
      state.winners = action.payload;
    },
    [getWinners.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export default winnersSlice.reducer;
